module.exports = __webpack_public_path__ + "static/media/icons.e94ee6e1.svg";